import { render, staticRenderFns } from "./HistoryRateList.vue?vue&type=template&id=397f81da"
import script from "./HistoryRateList.vue?vue&type=script&lang=js"
export * from "./HistoryRateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports